class SkillsListController {
    public currentPage: number;
    public itemsPerPage: number;

    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        this.currentPage = 1;
        this.itemsPerPage = 12;
    }

    public $onChanges = () => {
    
    }
    
    parseDate(item) {
        var date = new Date(item.start);
        return date;
    }
}

export const skillsListComponent = {
    bindings: {
        employeeSkills: "<"
    },
    controller: SkillsListController,
    template: require('./skills.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/skills/skills.list.component.ts